<div class="custom-slider">
    <ngx-slider [(value)]="value" [(highValue)]="highValue" (highValueChange)="onChange()" [options]="options"></ngx-slider>
  </div>